/* Copyright (c) 2023 MOCA Systems, Inc. All rights reserved. */

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
	standalone: true,
	selector: 'tp-stepper',
	templateUrl: './tp-stepper.component.html',
	styleUrls: ['./tp-stepper.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule],
})
export class TpStepperComponent {
	protected progressWidth: string;
	protected _currentStep: number;
	/* Array of steps titles */
	@Input() steps: string[] = [];

	/* If true just show the step number and the title */
	@Input() minimalisticHeader: boolean = false;

	/* If true hide the header */
	@Input() hideHeader: boolean = false;

	/* Current active step number */
	@Input() set currentStep(step: number) {
		this._currentStep = step;
		this.progressWidth = `calc(${(step / (this.steps.length - 1)) * 100}%)`;
	}

	constructor() {}
}
